<div [hidden]="showChatPannel">
  <!-- <div class="escalation pointer p-2" *ngIf="showEscalation" (click)="openChatbox()">
    {{escalationMessage}}
  </div>
  <img (click)="openChatbox()" style="width: 50px;height: 65px;position: fixed;top: 50vh;right: 5px;" src="../../images/tpiq-Q-bot.png"/> -->
</div>
<div class="row tpiq-chatbot" [hidden]="!showChatPannel">
  <div class="column medium-12 tpiq-chatbot-header">
    <div style="display: inline-block;" class="tpiq-chatbot-header-text">TaxPlanIQ ChatBot (Beta)</div>
    <span class="float-right" style="position: relative;top: 5px;">
      <span class="pointer tpiq-chatbot-close" (click)="closeChatbox()" style="padding: 0 4px 11px 4px; background-color: #fff;border-radius: 8px;">
        <mat-icon style="position: relative;top: 12px;">close</mat-icon>
      </span>
    </span>
  </div>
  <div  class="column medium-12" *ngIf="org !== 'ocrtest'">
    <iframe id="smarterCodesframeId" src="https://jaine.taxplaniq.com/" [ngStyle]="{'width':'100%', 'height':'90vh'}"
            frameborder="0"></iframe>
  </div>
  <div  class="column medium-12" *ngIf="org === 'ocrtest'">
    <iframe id="smarterCodesframeId" src="https://staging.chatbot.tpiq.smarter.codes" [ngStyle]="{'width':'100%', 'height':'90vh'}"
            frameborder="0"></iframe>
  </div>
</div>
